module.exports = __webpack_public_path__ + "img/chaveiro.001eeac2.svg";